var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJcbCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 16,
  fill: "none",
  viewBox: "0 0 24 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23.333,
  height: 15.333,
  x: 0.333,
  y: 0.333,
  fill: "#fff",
  stroke: "#D9DDE9",
  strokeWidth: 0.667,
  rx: 1.333
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-card_svg__a)",
  d: "M5.534 4.762c.02-.796.75-1.484 1.564-1.495.812-.003 1.624 0 2.436-.001-.002 2.663.005 5.327-.003 7.99-.031.787-.753 1.46-1.558 1.474-.813.003-1.627 0-2.441.002V9.407c.79.181 1.62.259 2.426.138.482-.075 1.01-.305 1.172-.791.12-.416.053-.854.07-1.28v-.992H7.806c-.006.656.013 1.312-.01 1.967-.038.403-.448.658-.838.645-.484.005-1.444-.341-1.444-.341-.002-1.229.014-2.767.021-3.991"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-card_svg__b)",
  d: "M15.304 8.19c.352.008.706-.015 1.057.012.355.064.44.587.125.759-.215.112-.47.042-.704.061h-.478zm1.26-.942c.079.269-.187.51-.453.473h-.807c.005-.253-.011-.528.008-.768.323.009.65-.018.97.014a.38.38 0 0 1 .283.281m1.943-3.982c.015.513.002 1.052.006 1.576q.002 3.191-.002 6.382c-.014.797-.74 1.49-1.555 1.506-.815.003-1.63 0-2.446.002V9.515c.889-.004 1.777.01 2.665-.006.412-.026.863-.29.883-.73.048-.443-.381-.75-.789-.798-.156-.004-.152-.044 0-.062.389-.081.694-.473.58-.864-.098-.412-.566-.572-.956-.57-.794-.006-1.588-.002-2.383-.003.005-.6-.01-1.202.009-1.802.063-.783.808-1.428 1.61-1.414z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#jcb-card_svg__c)",
  d: "M10.055 6.882c-.074.015-.015-.243-.034-.341.005-.62-.01-1.24.009-1.86.062-.786.813-1.433 1.62-1.415h2.374c-.003 2.663.004 5.327-.004 7.99-.031.787-.753 1.46-1.557 1.475-.814.003-1.628 0-2.442 0V9.09c.556.444 1.311.513 2.004.514.522 0 1.04-.079 1.548-.196V8.74c-.572.277-1.243.453-1.877.294a1 1 0 0 1-.755-.966c-.051-.46.227-.947.693-1.084.578-.176 1.209-.042 1.75.187.117.06.235.133.188-.056V6.59c-.906-.21-1.871-.286-2.782-.058-.264.072-.521.182-.735.35"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-card_svg__a",
  x1: 5.447,
  x2: 9.469,
  y1: 8.089,
  y2: 8.089,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F6EB6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006DBA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-card_svg__b",
  x1: 14.483,
  x2: 18.488,
  y1: 7.796,
  y2: 7.796,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#58B03A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#55B330"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb-card_svg__c",
  x1: 10.015,
  x2: 14.023,
  y1: 7.888,
  y2: 7.888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE0D3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E30138"
})))));
export default SvgJcbCard;